import { Alert, Dropdown } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import useApi, { API_ENDPOINTS } from '../../hooks/api';

// TODO: probably want to make these case insensitive
const FOOTBALL = 'FOOTBALL';
const AMF = 'NFL';

const byTeamName = (a, b) => {
  if (a.team_name < b.team_name) {
    return -1;
  }
  return 1;
};

export function SelectTeam({
  competitionId,
  disabled,
  id,
  label,
  onChange,
  placeholder,
  seasonId,
  selectedTeamId,
  sport,
}) {
  const intl = useIntl();
  const { errorMessage, isFetching, get, response } = useApi();

  useEffect(() => {
    async function getTeams() {
      if (competitionId && seasonId) {
        get(
          `${API_ENDPOINTS.videoService}/data/${sport}/competitions/${competitionId}/seasons/${seasonId}/team-stats`,
        );
      }
    }
    getTeams();
  }, [competitionId, seasonId]);

  const formatOption = ({ team_id: teamId, team_name: teamName }) => ({
    label: teamName,
    value: teamId,
  });

  const hasData = !!response?.data?.length;

  const selectLabel =
    label || intl.formatMessage({ defaultMessage: 'Select Team', id: 'ab83c' });

  const options = response?.data?.sort(byTeamName).map(formatOption) || [];

  const isDisabled = !hasData && !disabled;

  const initialPlaceholder =
    placeholder ||
    intl.formatMessage({ defaultMessage: 'Team Name', id: 'a4155' });
  const disabledPlaceholder = intl.formatMessage({
    defaultMessage: 'No teams found for selected competition',
    id: 'cbcf2',
  });
  const dynamicPlaceholder = isFetching
    ? intl.formatMessage({
        defaultMessage: 'Loading...',
        id: '8524d',
      })
    : initialPlaceholder;

  return errorMessage ? (
    <Alert
      type="error"
      title={intl.formatMessage({
        defaultMessage: 'Unable to fetch teams',
        id: 'b6ef8',
      })}
    >
      {errorMessage}
    </Alert>
  ) : (
    <Dropdown
      id={id}
      isDisabled={isDisabled}
      label={selectLabel}
      labelPosition="top"
      onChange={(selectedOption) => onChange(selectedOption.value)}
      options={options}
      placeholder={isDisabled ? disabledPlaceholder : dynamicPlaceholder}
      value={options.find((option) => option.value === selectedTeamId)}
      variant="secondary"
    />
  );
}

SelectTeam.propTypes = {
  competitionId: PropTypes.number,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  seasonId: PropTypes.number,
  selectedTeamId: PropTypes.number,
  sport: PropTypes.oneOf([FOOTBALL, AMF]),
};

SelectTeam.defaultProps = {
  competitionId: null,
  disabled: false,
  label: undefined,
  onChange: () => {},
  placeholder: undefined,
  seasonId: null,
  selectedTeamId: undefined,
  sport: FOOTBALL,
};

export default { SelectTeam };
